import { render, staticRenderFns } from "./ListaList.vue?vue&type=template&id=f1ddf7fe&"
import script from "./ListaList.vue?vue&type=script&lang=ts&"
export * from "./ListaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports